import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { onMounted, ref, reactive, watch, defineComponent } from 'vue';
import { getJobsList_url, getDictList_url } from '@/api'; //引入发送请求获取数据的方法

import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  components: {},
  name: 'Join',
  setup: function setup(props) {
    var select = ref(null);
    var selectTwo = ref(null);
    var jboList = ref([]);
    var location = ref('地点');
    var department = ref('部门');
    var searchValue = ref('');
    var locationList = ref([]);
    var workPlace = ref('');
    var departmentList = ref([]);

    var getDictList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getDictList_url({
                  dictType: type
                });

              case 2:
                res = _context.sent;

                // console.log(res,'获取地点部门成功');
                if (type === 'sys_work_place') {
                  locationList.value = res.data;
                }

                if (type === 'sys_dept') {
                  departmentList.value = res.data;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDictList(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    onMounted(function () {
      getJobsList();
      getDictList('sys_work_place');
      getDictList('sys_dept');
    });

    var upJoinClk = function upJoinClk() {
      select.value.$el.click();
    };

    var upJoinClkTwo = function upJoinClkTwo() {
      selectTwo.value.$el.click();
    };

    var getJobsList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  currentPage: 1,
                  pageSize: 999,
                  workPlace: workPlace.value,
                  department: '',
                  title: searchValue.value
                };
                _context2.next = 3;
                return getJobsList_url(params);

              case 3:
                res = _context2.sent;

                // console.log(res, '这是职位列表')
                if (res.code == 200) {
                  jboList.value = res.data.jobsList;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getJobsList() {
        return _ref2.apply(this, arguments);
      };
    }();

    var router = useRouter();
    var route = useRoute();

    var jobSelect = function jobSelect(value) {
      // console.log(value,'点击了');
      router.push({
        path: "/jobDetails",
        query: {
          jobId: value.jobsId
        }
      }); // window.open(`/jobDetails?id=${item.id}`)
    };

    var selectJob = function selectJob() {
      if (location.value == '地点') {} else {
        workPlace.value = location.value;
        getJobsList();
      }
    };

    return {
      select: select,
      jboList: jboList,
      location: location,
      department: department,
      upJoinClk: upJoinClk,
      upJoinClkTwo: upJoinClkTwo,
      jobSelect: jobSelect,
      getJobsList: getJobsList,
      selectTwo: selectTwo,
      searchValue: searchValue,
      locationList: locationList,
      departmentList: departmentList,
      selectJob: selectJob
    };
  }
});